
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dumpster-swaps",
      function () {
        return require("private-next-pages/dumpster-swaps/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dumpster-swaps"])
      });
    }
  